import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  alignSelf: 'flex-start',
};
